export function isQueryParamTruthy(queryParmValue: string): boolean {
  return queryParmValue === '1';
}
